import accessPermission from "./AccessPermission";

const Permissions = [
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.viewUpdatePermission
        },
        key: "quote-request"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.notAuthorizedPermission,
        },
        key: "illustration"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.notAuthorizedPermission,
        },
        key: "drop-ticket"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.notAuthorizedPermission,
        },
        key: "term"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "review-policy"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "virtual-sales-assistant"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.notAuthorizedPermission,
            CSA: accessPermission.notAuthorizedPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "covr-sales"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "ActivityCenter"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "product-centre"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.notAuthorizedPermission,
            CSA: accessPermission.notAuthorizedPermission,
            CRU: accessPermission.viewUpdatePermission,
            Ops: accessPermission.viewUpdatePermission,
            WGE: accessPermission.notAuthorizedPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "needs-analysis"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewUpdatePermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "case-view"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewUpdatePermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "notes"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "complete-suitability"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "upload-docs"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "Clients"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "initiate-activity"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "product-pages"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewUpdatePermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "inforce-policies"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.viewPermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "account"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.notAuthorizedPermission,
            CSA: accessPermission.notAuthorizedPermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "campaign"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.notAuthorizedPermission,
            CSA: accessPermission.notAuthorizedPermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewUpdatePermission,
        },
        key: "insurance"
    },
    {
        permission: {
            FA: accessPermission.viewPermission,
            RCSA: accessPermission.notAuthorizedPermission,
            CSA: accessPermission.notAuthorizedPermission,
            CRU: accessPermission.notAuthorizedPermission,
            Ops: accessPermission.notAuthorizedPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "resource-centre"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "Landing"
    },
    {
        permission: {
            FA: accessPermission.viewUpdatePermission,
            RCSA: accessPermission.viewUpdatePermission,
            CSA: accessPermission.viewPermission,
            CRU: accessPermission.viewPermission,
            Ops: accessPermission.viewPermission,
            WGE: accessPermission.viewPermission,
            RIS: accessPermission.viewPermission,
        },
        key: "Products"
    },
];

const navLinkPermissions = {
    "Resource Center": ["RCSA", "CSA", "CRU", "Ops"],
    "Campaigns": ["RCSA", "CSA", "CRU", "Ops"],
    "Insurance Tools": ["RCSA", "CSA", "WGE"],
}

const getPermission = (userRole, key = null) => {
    let url = window.location.pathname.split('/');
    const permissionKey = key === null ? url : key;
    const data = Permissions.find(element => permissionKey.includes(element.key));
    if (data) {
        return data.permission[`${userRole}`];
    }
    return null;
}

const checkHiddenFields = (userRole, key) => {
    const permission = getPermission(userRole, key);
    if (permission === accessPermission.notAuthorizedPermission) {
        return true;
    }
    return false;
}

const checkDisabledFields = (userRole, key) => {
    const permission = getPermission(userRole, key);
    if (permission === accessPermission.viewPermission) {
        return true;
    }
    return false;
}

const getNavLinkPermission = (userRole, navLink) => {
    const navLinkItem = navLinkPermissions[navLink];
    let isHidden = false;
    if (navLinkItem) {
        const hasRole = navLinkItem.find((navLink) => navLink === userRole);
        if (hasRole) {
            isHidden = true;
        }
    }
    return isHidden;
}

export { checkHiddenFields, getPermission, getNavLinkPermission, checkDisabledFields };



// WEBPACK FOOTER //
// ./src/components/Helpers/CheckAccess.js